import { render, staticRenderFns } from "./ProductsGoodsTypeAutocompleteField.vue?vue&type=template&id=241d7664"
import script from "./ProductsGoodsTypeAutocompleteField.vue?vue&type=script&lang=ts"
export * from "./ProductsGoodsTypeAutocompleteField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports